import { render, staticRenderFns } from "./departmentDialog.vue?vue&type=template&id=a3929480&"
import script from "./departmentDialog.vue?vue&type=script&lang=js&"
export * from "./departmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./departmentDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports